<script>
    import { library, icon } from '@fortawesome/fontawesome-svg-core';
    import { fas } from '@fortawesome/free-solid-svg-icons';
    import { far } from '@fortawesome/free-regular-svg-icons';
    import { fab } from '@fortawesome/free-brands-svg-icons'
    library.add(fas);
    library.add(far);
    library.add(fab);
    export let prefix = 'fas';
    export let iconName = 'user';
    const i = icon({
        prefix,
        iconName
    });
</script>

<i>{@html i.html}</i>